import React from "react";
import ArticlePage from "../ArticlePage";

const Slawn = () => (
  <ArticlePage
    title="Slawn"
    subtitle="Art"
    leadImage="/img/culture/art.webp"
    body={[
      "Olaolu Slawn is a Lagos-born, London-based artist whose exuberant, cartoon-inflected paintings, sculptures and murals have made him one of the most talked-about young voices in contemporary art. His work draws from graffiti, football culture, animation and childhood iconography, delivered with a raw energy that has resonated with a generation of new collectors.",
      "In the last few years Slawn has expanded from wall pieces and canvas into ceramics, plush editions and large-scale sculptural work, collaborating across fashion, music and design without leaving his signature visual world behind.",
      "For his own words, exhibition schedule, editions and shop, visit olaoluslawn.com. Coverage of his shows and interviews can be found across major art press — links below.",
    ]}
    sources={[
      {
        brand: "Official site",
        title: "olaoluslawn.com — bio, shop and news",
        host: "olaoluslawn.com",
        href: "https://olaoluslawn.com",
        accent: "#ff6b9d",
      },
    ]}
    primaryHref="https://olaoluslawn.com"
    primaryLabel="Visit olaoluslawn.com"
  />
);

export default Slawn;
